import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { postData } from '../../../services/api';

const Contactv2Banner = () => {
    const { i18n, t } = useTranslation();
    const [settings, setSettings] = useState({});
    const [description, setDescription] = useState('');

    const ContactData = {
        title: t('contact_us'),
        description: description,
    }

    useEffect(() => {
        async function settingsData() {
            try {
                const result = await postData("setting/details", {});
                if (result.data) {
                    setSettings(result.data);
                } else {
                    console.log("settings list message", result.message);
                }
            } catch (error) {
                console.log("Error settings list catch", error.message);
            }
        }
        settingsData();
    }, [])

    useEffect(() => {
        if (settings && settings.about) {
            setDescription(settings?.about?.[i18n?.language])
        }
    }, [settings, i18n])

    return (
        <section className="relative w-full py-10 lg:py-16 bg-gradient-to-b from-slate-50 via-white to-slate-50">
            {/* Decorative Background Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-0 right-0 w-96 h-96 bg-dark-teal-500/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-slate-300/10 rounded-full blur-3xl"></div>
            </div>

            <div className="relative w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="max-w-3xl w-full mx-auto text-center mb-12 lg:mb-16 space-y-6">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-dark-teal-500/10 rounded-full mb-4">
                        <i className="fa-solid fa-message-dots text-dark-teal-500"></i>
                        <span className="text-sm font-semibold text-dark-teal-600 font-PlusJakartaSans uppercase tracking-wider">
                            Get In Touch
                        </span>
                    </div>
                    
                    <h2 
                        className="capitalize text-slate-950 text-3xl xs:text-4xl !leading-tight lg:text-5xl xl:text-6xl font-extrabold font-PlusJakartaSans" 
                        dangerouslySetInnerHTML={{__html: ContactData.title}}
                    ></h2>
                    
                    <div 
                        className="text-base xs:text-lg lg:text-xl text-slate-500 font-PlusJakartaSans leading-relaxed max-w-2xl mx-auto" 
                        dangerouslySetInnerHTML={{__html: ContactData.description}}
                    ></div>
                </div>

                
                {/* <div className="max-w-5xl relative mx-auto w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                        
                        <div className="group relative bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 border-2 border-slate-100 hover:border-dark-teal-500 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-dark-teal-500/20">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-dark-teal-500/5 to-transparent rounded-bl-full"></div>
                            
                            <div className="relative flex flex-col items-start gap-4">
                                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-dark-teal-500 to-dark-teal-600 text-white flex items-center justify-center shadow-lg shadow-dark-teal-500/30 group-hover:scale-110 transition-transform duration-300">
                                    <i className="fa-solid fa-envelope text-2xl"></i>
                                </div>
                                
                                <div className="space-y-2">
                                    <div className="text-xl lg:text-2xl font-bold font-PlusJakartaSans text-slate-950">
                                        {t('email_us')}
                                    </div>
                                    <a 
                                        href={`mailto:${settings?.email}`}
                                        className="text-base lg:text-lg font-PlusJakartaSans text-dark-teal-500 hover:text-dark-teal-600 transition-colors duration-200 break-all"
                                    >
                                        {settings?.email}
                                    </a>
                                    <p className="text-sm text-slate-400 font-PlusJakartaSans">
                                        Send us an email anytime
                                    </p>
                                </div>
                            </div>
                        </div>

                       
                        {settings?.phone && (
                            <div className="group relative bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 border-2 border-slate-100 hover:border-dark-teal-500 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-dark-teal-500/20">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-dark-teal-500/5 to-transparent rounded-bl-full"></div>
                                
                                <div className="relative flex flex-col items-start gap-4">
                                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-slate-700 to-slate-800 text-white flex items-center justify-center shadow-lg shadow-slate-700/30 group-hover:scale-110 transition-transform duration-300">
                                        <i className="fa-solid fa-phone text-2xl"></i>
                                    </div>
                                    
                                    <div className="space-y-2">
                                        <div className="text-xl lg:text-2xl font-bold font-PlusJakartaSans text-slate-950">
                                            {t('call_us')}
                                        </div>
                                        <a 
                                            href={`tel:${settings?.phone}`}
                                            className="text-base lg:text-lg font-PlusJakartaSans text-dark-teal-500 hover:text-dark-teal-600 transition-colors duration-200"
                                        >
                                            {settings?.phone}
                                        </a>
                                        <p className="text-sm text-slate-400 font-PlusJakartaSans">
                                            Available Mon-Fri, 9am-6pm
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        
                        {settings?.address && (
                            <div className="group relative bg-white rounded-2xl p-8 shadow-lg shadow-slate-200/50 border-2 border-slate-100 hover:border-dark-teal-500 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-dark-teal-500/20">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-dark-teal-500/5 to-transparent rounded-bl-full"></div>
                                
                                <div className="relative flex flex-col items-start gap-4">
                                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-dark-teal-500 to-dark-teal-600 text-white flex items-center justify-center shadow-lg shadow-dark-teal-500/30 group-hover:scale-110 transition-transform duration-300">
                                        <i className="fa-solid fa-location-dot text-2xl"></i>
                                    </div>
                                    
                                    <div className="space-y-2">
                                        <div className="text-xl lg:text-2xl font-bold font-PlusJakartaSans text-slate-950">
                                            {t('visit_us')}
                                        </div>
                                        <p className="text-base lg:text-lg font-PlusJakartaSans text-slate-600">
                                            {settings?.address}
                                        </p>
                                        <p className="text-sm text-slate-400 font-PlusJakartaSans">
                                            Come visit our office
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        
                        <div className="group relative bg-gradient-to-br from-dark-teal-500 to-dark-teal-600 rounded-2xl p-8 shadow-lg shadow-dark-teal-500/30 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-dark-teal-500/40 md:col-span-2 lg:col-span-1">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full"></div>
                            
                            <div className="relative flex flex-col items-start gap-4">
                                <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm text-white flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                    <i className="fa-brands fa-rocketchat text-2xl"></i>
                                </div>
                                
                                <div className="space-y-3">
                                    <div className="text-xl lg:text-2xl font-bold font-PlusJakartaSans text-white">
                                        Follow Us
                                    </div>
                                    <p className="text-sm text-white/80 font-PlusJakartaSans">
                                        Stay connected on social media
                                    </p>
                                    <div className="flex gap-3 pt-2">
                                        {settings?.facebook && (
                                            <a 
                                                href={settings?.facebook}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-lg bg-white/20 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                                            >
                                                <i className="fa-brands fa-facebook-f"></i>
                                            </a>
                                        )}
                                        {settings?.twitter && (
                                            <a 
                                                href={settings?.twitter}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-lg bg-white/20 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                                            >
                                                <i className="fa-brands fa-twitter"></i>
                                            </a>
                                        )}
                                        {settings?.linkedin && (
                                            <a 
                                                href={settings?.linkedin}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-lg bg-white/20 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                                            >
                                                <i className="fa-brands fa-linkedin-in"></i>
                                            </a>
                                        )}
                                        {settings?.instagram && (
                                            <a 
                                                href={settings?.instagram}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-10 h-10 rounded-lg bg-white/20 hover:bg-white/30 backdrop-blur-sm flex items-center justify-center text-white transition-all duration-200 hover:scale-110"
                                            >
                                                <i className="fa-brands fa-instagram"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Additional Info Banner */}
                <div className="mt-12 lg:mt-16 max-w-4xl mx-auto">
                    <div className="bg-gradient-to-r from-slate-50 to-slate-100 rounded-2xl p-6 lg:p-8 border border-slate-200">
                        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-xl bg-dark-teal-500 flex items-center justify-center flex-shrink-0">
                                    <i className="fa-solid fa-envelope text-white text-xl"></i>
                                </div>
                                <div>
                                    <h3 className="text-lg font-bold text-slate-950 font-PlusJakartaSans">{t('email_us')}: 
                                        <a 
                                            href={`mailto:${settings?.email}`}
                                            className="text-base lg:text-lg font-PlusJakartaSans text-dark-teal-500 hover:text-dark-teal-600 transition-colors duration-200 break-all"
                                        >
                                        {settings?.email}
                                        </a>
                                    </h3>
                                    <p className="text-sm text-slate-500 font-PlusJakartaSans">Send us an email anytime</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-2 text-dark-teal-500">
                                <i className="fa-solid fa-shield-check text-2xl"></i>
                                <span className="text-sm font-semibold font-PlusJakartaSans">100% Secure</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contactv2Banner;